import type { Locale } from "../schema/Locale.js";

const formatCache: Partial<Record<`${string}-${Locale}-${boolean}`, Intl.NumberFormat>> = {};
function createFormat(currency: string, locale: Locale, withFraction: boolean): Intl.NumberFormat {
	const cached = formatCache[`${currency}-${locale}-${withFraction}`];
	if (cached) {
		return cached;
	}

	const format = new Intl.NumberFormat(locale, {
		style: "currency",
		currency,
		minimumFractionDigits: withFraction ? 2 : 0,
		maximumFractionDigits: 2,
	});
	formatCache[`${currency}-${locale}-${withFraction}`] = format;
	return format;
}

export function formatPrice(number: number | string, currency: string, locale: Locale, withFraction: boolean): string {
	return createFormat(currency, locale, withFraction).format(typeof number === "string" ? parseFloat(number) : number);
}

export function getCurrencySymbol(currency: string, locale: Locale): string {
	return (
		createFormat(currency, locale, false)
			.formatToParts(0)
			.find((part) => part.type === "currency")?.value ?? currency
	);
}
